import "./Footer.css";

export function Footer() {
  return (
    <>
      <div className="bg-black w-full h-12">
        <p className="text-white text-center pt-3 font-light text-roboto">
          {" "}
          Good To See You ❤️{" "}
        </p>
      </div>
    </>
  );
}
